import React from "react";
import styled from "styled-components";

function DivisionBox({ children, style }) {
  return <OuterDiv style={style}>{children}</OuterDiv>;
}

export default DivisionBox;

const OuterDiv = styled.div`
  /* border: 1px solid #e4e4e7; */
  border: 1px solid rgba(255, 255, 255, 1);
  box-shadow: inset 2px 2px 5px rgba(0, 0, 0, 0.08), inset -1px -1px 3px rgba(255, 255, 255, 0.9);
  /* background: white; */
  padding: 24px;
  border-radius: 10px;
  height: 460px;
  width: 100%;
  overflow: scroll;
  transition: all 0.25s ease;

  /* &:hover {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.03);
    scale: 1.005;
  } */
`;
